// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
console.log('main....');
import Vue from 'vue'
import './plugins'
import './error'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import TreeView from 'vue-json-tree-view'
import VueCoreVideoPlayer from 'vue-core-video-player'
import './assets/style.css'

Vue.config.productionTip = false

Vue.use(VueCoreVideoPlayer)
Vue.use(TreeView)

store.commit('auth/init');
/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js